import React from "react";
import { AuditLog } from "@common/types/auditLog";
import { AuditLogActor } from "../AuditLogActor";

interface Props {
    log: AuditLog;
}

export const TransactionLogTransferMatchContent: React.FC<Props> = ({
    log,
}) => {
    const authorComponent = (
        <AuditLogActor
            actorId={log.actorId}
            actorName={log.actorName}
            actorType={log.actorType}
            log={log}
        />
    );
    const transferMatched =
        log.diff.find((d) => d.field === "pairedTransferId")?.after?.value !==
        null;

    const oldCategoryLabel =
        log.diff.find((d) => d.field === "categoryId")?.before?.valueLabel ??
        "";
    const newCategoryLabel =
        log.diff.find((d) => d.field === "categoryId")?.after?.valueLabel ?? "";
    const pairedTransfer = log.diff.find((d) => d.field === "pairedTransferId");

    const sameCategory = newCategoryLabel === oldCategoryLabel;

    if (transferMatched) {
        if (sameCategory) {
            return (
                <>
                    {authorComponent} matched transaction with{" "}
                    <strong>{pairedTransfer?.after?.valueLabel}</strong>{" "}
                    transaction.
                </>
            );
        }

        return (
            <>
                {authorComponent} changed category from{" "}
                <strong>{oldCategoryLabel}</strong> to{" "}
                <strong>{newCategoryLabel}</strong> because transaction was
                matched with{" "}
                <strong>{pairedTransfer?.after?.valueLabel}</strong>{" "}
                transaction.
            </>
        );
    }

    if (sameCategory) {
        return (
            <>
                {authorComponent} unmatched transaction with{" "}
                <strong>{pairedTransfer?.before?.valueLabel}</strong>{" "}
                transaction.
            </>
        );
    }

    return (
        <>
            {authorComponent} changed category from{" "}
            <strong>{oldCategoryLabel}</strong> to{" "}
            <strong>{newCategoryLabel}</strong> because transaction was
            unmatched with <strong>{pairedTransfer?.before?.valueLabel}</strong>{" "}
            transaction.
        </>
    );
};
